import * as React from 'react'
import { cn } from '@core/utils'

const BottomSheetFooter = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('mt-auto flex flex-col gap-2', className)} {...props} />
)
BottomSheetFooter.displayName = 'BottomSheetFooter'

export default BottomSheetFooter
